// Close sidebar on Escape
export function keydownListenter(e: KeyboardEvent) {
    if (e.key === 'Escape') {
        const sidebar = document.getElementById('mobile-sidebar');
        const overlay = document.getElementById('mobile-sidebar-overlay');
        if (sidebar && overlay && !sidebar.classList.contains('translate-x-full')) {
            sidebar.classList.add('translate-x-full');
            overlay.classList.add('opacity-0', 'pointer-events-none');
            overlay.classList.remove('opacity-100');
            document.documentElement.classList.remove('overflow-hidden');
        }
    }
}
